import $ from 'jquery';
import Swiper from 'swiper/bundle';

$('.js-slider-grid .swiper').each((i, slider) => {
	if($(window).width() < 1023) {
		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			allowTouchMove: false,
			navigation: {
				nextEl: '.slider__btn--next',
				prevEl: '.slider__btn--prev',
			},
			breakpoints: {
				/* when window width is <= 320px */
				768: {
					slidesPerView: 2,
				}
			},
		});
	}
});

$('.js-telecom-plans-slider').each((i, slider) => {
	const swiper = new Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},
		grid: {
			fill: 'row',
			rows: 2,
		},
		breakpoints: {
			1023: {
				slidesPerColumn: 1,
				slidesPerView: 3,
				grid: {
					rows: 1,
				}
			},
			580: {
				slidesPerColumn: 1,
				slidesPerView: 2,
				grid: {
					rows: 1,
				}
			}
		},
	});
})
